module.exports = __webpack_public_path__ + "static/media/Cleaner.cca0b198.svg";